import { FaEgg } from "react-icons/fa6";
import '../css/pages/partial-pages.css';
function SomethingElse(){

  return(
    <section className="easter-egg">
      <h4>Noway! You found the easter egg!</h4>
      <p>KeyPhrase = "Your head a SPLODE"</p>
      <p>Type the KeyPhrase into your Eternal September Agent's input and you'll unlock a new skin for them</p>
      <p>
        <FaEgg className="easter-egg-icon"></FaEgg>
      </p>
    </section>
  );
}
export default SomethingElse;